// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th[data-v-3d2b4626] {\n  color: white !important;\n}[dir] .vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th[data-v-3d2b4626] {\n  padding: 10px 15px;\n  background: rgba(var(--vs-primary), 1) !important;\n}\n", ""]);
// Exports
module.exports = exports;
